import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../../core/service/v2/abstractRepositoryV2';
import {TreatmentModel} from '../../../api/model/treatment.model';

@Injectable({providedIn: 'root'})
export class TreatmentRepository extends AbstractRepositoryV2<TreatmentModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('Treatment', serviceElementsFactory, injector);
    }
}
